export default __webpack_public_path__ + "static/media/airtime.9d810b2e.svg";